import React, { useRef, useState, useEffect} from 'react'
import "./ForgotPassword.css"
import {auth} from "../../../firebase/utils"
import { Button, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import "../Signup/Signup.css";
import { Form, Alert } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { signUpUserStart } from '../../../redux/User/user.actions';
import LogoMark from "../../../images/LogoMark.png";
import GreenHeader from '../../../components/GreenHeader/GreenHeader'



const myStyle={
  backgroundImage: `url(${LogoMark})`,
  backgroundColor: '#016b37',
  height:'150vh',
  marginTop:'-10px',
  fontSize:'50px',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};


function ForgotPassword() {


  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isloading, setLoading] = useState(false);


  const resetPassword = async (e) => {
    setLoading(true);
    e.preventDefault();
    console.log(email);
    auth.sendPasswordResetEmail( email).then(() => {
      console.log("Password reset email sent");
      setLoading(false);
      setTimeout(() => {
        setMessage("Sent! Check your email or spam folder to reset password")
      })
    }
    ).catch(error => {
      console.log(error);
      setLoading(false);
      setTimeout(() => {
        setError("Email not found");
      })
    });

   
  }
  
  return (

    <div>


    <div style={myStyle}>

  <GreenHeader/>

    <div className="signUpCont">

    <h1 className="sUP">

    <span>Recover Password</span>

    </h1>

       
      <div><p className='pTxt'>Enter your Email and instructions will be sent to you!</p></div>

      <form className='form' onSubmit={resetPassword}>
     

      {message && (<p className='message'>{message}</p>)}
      {error && (<p className='error2'>{error}</p>)}

      <div className='label2'><p>Email Address*</p></div> 
    
      <input value={email} className="signUpEmail" onChange={(e) => setEmail(e.target.value)} type="text3" placeholder="Enter your email"  required/>
   

      <button className='signUpBtn' >
      {isloading ? <Spinner animation="border"  role="status" size="sm" variant="primary" /> : <p>Reset Password</p>}

      </button>


        <div className='dha'>Go back to<Link to="/login"> Login Page</Link></div>
    
      </form>

    </div>
    </div>
   
    
    </div>
  )
} 

export default ForgotPassword